/* Cazameeza PDP V4 — Winter Version only. */
(function () {
  'use strict';

  var TIERS = [
    { goal: 300000, discount: 10 },
    { goal: 500000, discount: 15 },
    { goal: 700000, discount: 20 }
  ];

  var WINTER_HANDLES = [
    '3pieces-winter-vibe-set','burgundy-heritage-long-cardigan','chill-mode-set-3-pieces',
    'color-block-maxi-dress','floral-texture-two-piece-set','knitwear-suit-with-white-heart-2-pieces',
    'luxury-buttoned-knit-co-ord-2-pieces','midnight-blue-2-pieces','midnight-duo-2-pieces',
    'monogram-knit-pants','copy-silver-star-pullover','ribbed-winter-knit-set-2-pieces',
    'shiny-star-2-pieces','silver-star-pullover','striped-knit-lounge-pants','two-ton-jacket',
    'two-tone-zip-lounge-set-2-pieces','warm-whisper-pullover','winter-ease-set-2-pieces'
  ];

  var PRODUCT_COPY = {
    '3pieces-winter-vibe-set': {
      intro: 'A coordinated three-piece winter set that gives you a complete look while keeping every piece easy to style separately.',
      reasons: ['3-piece coordinated set', 'Wear the pieces together or separately', 'More than one styling option from one set']
    },
    'warm-whisper-pullover': {
      intro: 'A winter pullover with an easy silhouette that works naturally as an everyday layer.',
      reasons: ['Easy winter layering piece', 'Simple to pair with different bottoms', 'A clean standalone winter look']
    },
    'two-ton-jacket': {
      intro: 'A two-tone winter jacket that adds an easy outer layer and a stronger finish to simple everyday looks.',
      reasons: ['Distinct two-tone design', 'Easy outer layer', 'Pairs naturally with simple winter separates']
    },
    'burgundy-heritage-long-cardigan': {
      intro: 'A long burgundy cardigan designed as an easy finishing layer across different winter looks.',
      reasons: ['Long-line cardigan silhouette', 'Easy layering piece', 'Simple to restyle across different outfits']
    }
  };

  var COMPLETE_LOOK = {
    '3pieces-winter-vibe-set': ['two-ton-jacket','burgundy-heritage-long-cardigan','copy-silver-star-pullover','monogram-knit-pants','striped-knit-lounge-pants'],
    'warm-whisper-pullover': ['monogram-knit-pants','striped-knit-lounge-pants','two-ton-jacket','burgundy-heritage-long-cardigan','midnight-blue-2-pieces'],
    'two-ton-jacket': ['warm-whisper-pullover','copy-silver-star-pullover','monogram-knit-pants','striped-knit-lounge-pants','midnight-blue-2-pieces'],
    'burgundy-heritage-long-cardigan': ['warm-whisper-pullover','copy-silver-star-pullover','monogram-knit-pants','striped-knit-lounge-pants','midnight-duo-2-pieces'],
    'monogram-knit-pants': ['warm-whisper-pullover','copy-silver-star-pullover','two-ton-jacket','burgundy-heritage-long-cardigan','chill-mode-set-3-pieces'],
    'striped-knit-lounge-pants': ['warm-whisper-pullover','copy-silver-star-pullover','two-ton-jacket','burgundy-heritage-long-cardigan','chill-mode-set-3-pieces'],
    'copy-silver-star-pullover': ['monogram-knit-pants','striped-knit-lounge-pants','two-ton-jacket','burgundy-heritage-long-cardigan','warm-whisper-pullover'],
    'silver-star-pullover': ['monogram-knit-pants','striped-knit-lounge-pants','two-ton-jacket','burgundy-heritage-long-cardigan','warm-whisper-pullover'],
    'winter-ease-set-2-pieces': ['two-ton-jacket','burgundy-heritage-long-cardigan','warm-whisper-pullover','copy-silver-star-pullover','monogram-knit-pants'],
    'midnight-blue-2-pieces': ['two-ton-jacket','burgundy-heritage-long-cardigan','warm-whisper-pullover','copy-silver-star-pullover','monogram-knit-pants']
  };

  function q(selector, root) { return (root || document).querySelector(selector); }
  function qa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function cfg() {
    var node = q('#caza-winter-pdp-config');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (e) { return {}; }
  }

  function main() { return q('.t4s-section-main-product'); }
  function info() { return q('.t4s-section-main-product .t4s-product__info-container'); }
  function form() { return q('.t4s-section-main-product form.t4s-form__product'); }

  function money(cents) {
    var n = Math.max(0, Math.round(Number(cents || 0) / 100));
    try { return new Intl.NumberFormat('en-EG', { maximumFractionDigits: 0 }).format(n) + ' LE'; }
    catch (e) { return String(n) + ' LE'; }
  }

  function variantData(config) {
    var frm = form();
    var id = frm && q('[name="id"]', frm);
    var json = q('.t4s-section-main-product .pr_variants_json');
    if (id && json) {
      try {
        var variants = JSON.parse(json.textContent || '[]');
        var selected = variants.find(function (v) { return String(v.id) === String(id.value); });
        if (selected) return selected;
      } catch (e) {}
    }
    return {
      id: config.initialVariantId,
      price: Number(config.initialVariantPrice || 0),
      compare_at_price: null,
      available: true
    };
  }

  function quantity() {
    var frm = form();
    var input = frm && q('[data-quantity-value], input[name="quantity"]', frm);
    var n = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function nextTier(total) {
    for (var i = 0; i < TIERS.length; i += 1) if (total < TIERS[i].goal) return TIERS[i];
    return null;
  }

  function unlockedDiscount(total) {
    var d = 0;
    TIERS.forEach(function (tier) { if (total >= tier.goal) d = tier.discount; });
    return d;
  }

  function openPolicy() {
    var tab = q('#cm-policy-tab');
    if (tab) { tab.click(); return; }
    var overlay = q('#cm-policy-overlay');
    if (overlay) {
      overlay.classList.add('cm-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function openSize() {
    var trigger = q('[data-caza-size-open]');
    if (trigger) trigger.click();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function cleanDescription() {
    var source = q('.t4s-section-main-product t4s-product-description .t4s-product__description');
    if (!source) return { html: '', intro: '' };

    var clone = source.cloneNode(true);
    qa('script, style, .t4s-product__description_readm, [data-readmore]', clone).forEach(function (n) { n.remove(); });

    var title = (q('.t4s-section-main-product .t4s-product__title') || {}).textContent || '';
    var titleKey = title.trim().toLowerCase();

    qa('h1,h2,h3,h4,h5,h6,p,li', clone).forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text === '•' || text === '-') { node.remove(); return; }
      if (titleKey && text.toLowerCase() === titleKey) node.remove();
    });

    var paragraphs = qa('p', clone).map(function (p) {
      return (p.textContent || '').replace(/\s+/g, ' ').trim();
    }).filter(Boolean);

    var handle = cfg().handle || '';
    var isWinter = WINTER_HANDLES.indexOf(handle) !== -1;
    var intro = '';
    for (var i = 0; i < paragraphs.length; i += 1) {
      var text = paragraphs[i];
      if (titleKey && text.toLowerCase() === titleKey) continue;
      if (isWinter && /summer/i.test(text)) continue;
      if (text.length < 25) continue;
      intro = text.length > 185 ? text.slice(0, 182).replace(/\s+\S*$/, '') + '…' : text;
      break;
    }

    return { html: clone.innerHTML.trim(), intro: intro };
  }

  function purgeOldV3() {
    qa('.caza-v3-confidence,.caza-v3-saver,.caza-v3-info,.caza-smart-look-host').forEach(function (n) { n.remove(); });
    document.documentElement.classList.remove('caza-pdp-v3-page');
    var root = main();
    if (root) root.classList.remove('caza-pdp-v3');
  }

  function basePage() {
    var root = main();
    if (!root) return;
    root.classList.add('caza-pdp-v4');
    document.documentElement.classList.add('caza-pdp-v4-page');

    qa('.is-t4s-name__code', root).forEach(function (n) { n.classList.add('caza-v4-hide'); });
    qa('.t4s-liquid_custom_liquid_pUTAWc', document).forEach(function (n) { n.classList.add('caza-v4-hide'); });

    var helper = q('[data-caza-size-helper]', root);
    if (helper) {
      helper.classList.add('caza-size-helper--v4');
      var strong = q('[data-caza-size-open] strong', helper);
      var small = q('[data-caza-size-open] small', helper);
      if (strong && strong.textContent !== 'مش متأكدة من مقاسك؟') strong.textContent = 'مش متأكدة من مقاسك؟';
      if (small && small.textContent !== 'هنساعدك تختاري المقاس الأنسب قبل ما تأكدي الأوردر') small.textContent = 'هنساعدك تختاري المقاس الأنسب قبل ما تأكدي الأوردر';
    }

    var modal = q('[data-caza-modal]');
    if (modal) modal.classList.add('caza-size-modal--v4');
    var sticky = q('.t4s-sticky-atc');
    if (sticky) sticky.classList.add('caza-sticky-v4');
  }

  function buildAboveFold(config, description) {
    var container = info();
    var variants = q('.t4s-section-main-product .t4s-product-form__variants');
    if (!container || !variants) return;

    var existing = q('.caza-v4-product-story', container);
    if (existing) existing.remove();

    var curated = PRODUCT_COPY[config.handle] || {};
    var intro = curated.intro || description.intro;
    var reasons = curated.reasons || [];

    if (!intro && !reasons.length) return;

    var story = document.createElement('section');
    story.className = 'caza-v4-product-story';
    story.innerHTML =
      (intro ? '<p class="caza-v4-intro">' + escapeHtml(intro) + '</p>' : '') +
      (reasons.length ? '<div class="caza-v4-piece-reasons"><span>Why this piece</span><ul>' + reasons.map(function (r) { return '<li>' + escapeHtml(r) + '</li>'; }).join('') + '</ul></div>' : '');

    variants.insertAdjacentElement('beforebegin', story);
  }

  function buildPriceSaving(config, cartSubtotal) {
    var priceWrap = q('.t4s-section-main-product .t4s-product__price-review');
    var priceEl = q('.t4s-section-main-product .t4s-product-price');
    if (!priceWrap || !priceEl) return;

    qa('.caza-v4-price-meta', priceWrap).forEach(function (n) { n.remove(); });

    var v = variantData(config);
    var price = Number(v.price || config.initialVariantPrice || 0);
    var compare = Number(v.compare_at_price || 0);
    var qty = quantity();
    var projected = Math.max(0, Number(cartSubtotal || 0)) + price * qty;
    var tier = nextTier(projected);
    var unlocked = unlockedDiscount(projected);

    var meta = document.createElement('div');
    meta.className = 'caza-v4-price-meta';

    if (compare > price) {
      var save = document.createElement('span');
      save.className = 'caza-v4-save';
      save.textContent = 'Save ' + money(compare - price);
      meta.appendChild(save);
    }

    priceEl.insertAdjacentElement('afterend', meta);
  }

  function premiumAov() { return; }

  function icon(name) {
    var paths = {
      cod: '<path d="M4 7h16v11H4z"/><path d="M7 7V5h10v2"/>',
      card: '<path d="M4 6h16v12H4z"/><path d="M4 10h16"/>',
      exchange: '<path d="M7 7h10l-2.5-2.5"/><path d="M17 17H7l2.5 2.5"/>',
      size: '<path d="M5 17L17 5l2 2L7 19H5z"/>'
    };
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + paths[name] + '</svg>';
  }

  function buildTrustAndBrand() {
    var container = info();
    if (!container) return;

    var aov = q('.t4s-product-form__variants', container);
    if (!aov) return;

    if (!q('.caza-v4-trust', container)) {
      var trust = document.createElement('section');
      trust.className = 'caza-v4-trust';
      trust.innerHTML =
        '<span>' + icon('cod') + '<b>Cash on delivery</b></span>' +
        '<button type="button" data-v4-policy>' + icon('exchange') + '<b>Exchange & returns</b></button>' +
        '<button type="button" data-v4-size>' + icon('size') + '<b>Size assistance</b></button>';
      aov.insertAdjacentElement('afterend', trust);
      q('[data-v4-policy]', trust).addEventListener('click', openPolicy);
      q('[data-v4-size]', trust).addEventListener('click', openSize);
    }

    if (!q('.caza-v4-brand', container)) {
      var brand = document.createElement('section');
      brand.className = 'caza-v4-brand';
      brand.innerHTML =
        '<div class="caza-v4-section-head"><span>BUY WITH CONFIDENCE</span><h2>Why Cazameeza?</h2></div>' +
        '<div class="caza-v4-brand-grid">' +
          '<div><strong>Choose your size with help</strong><p>Use our size helper before ordering whenever you need more confidence in the fit.</p></div>' +
          '<div><strong>Flexible checkout</strong><p>Pay by card or choose cash on delivery at checkout.</p></div>' +
          '<div><strong>Policy always within reach</strong><p>Exchange and returns are available. Open the full store policy before you order.</p><button type="button" data-v4-brand-policy>View policy →</button></div>' +
        '</div>';
      var trustNode = q('.caza-v4-trust', container);
      trustNode.insertAdjacentElement('afterend', brand);
      q('[data-v4-brand-policy]', brand).addEventListener('click', openPolicy);
    }
  }

  function buildDescription(description) {
    var container = info();
    if (!container || q('.caza-v4-about', container)) return;

    var about = document.createElement('section');
    about.className = 'caza-v4-about';
    about.innerHTML =
      '<div class="caza-v4-section-head"><span>PRODUCT STORY</span><h2>About this piece</h2></div>' +
      (description.html ? '<div class="caza-v4-description">' + description.html + '</div>' : '<p class="caza-v4-empty-copy">More verified product details are being prepared for this piece.</p>');

    var brand = q('.caza-v4-brand', container);
    if (brand) brand.insertAdjacentElement('afterend', about);
    else container.appendChild(about);

    var support = document.createElement('div');
    support.className = 'caza-v4-support';
    support.innerHTML =
      '<button type="button" data-v4-support-size><span>Size & fit</span><small>Open size assistance</small><b>→</b></button>' +
      '<button type="button" data-v4-support-policy><span>Delivery, exchange & returns</span><small>View the full store policy</small><b>→</b></button>';
    about.insertAdjacentElement('afterend', support);
    q('[data-v4-support-size]', support).addEventListener('click', openSize);
    q('[data-v4-support-policy]', support).addEventListener('click', openPolicy);
  }

  function fetchProduct(handle, index) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product unavailable'); return r.json(); })
      .then(function (p) {
        var image = p.featured_image || (p.images && p.images[0]);
        if (image && typeof image !== 'string') image = image.src || '';
        var price = Number(p.price || 0);
        if (!p.available || !image || !price) return null;
        return { p: p, image: image, price: price, index: index };
      }).catch(function () { return null; });
  }

  function completeCard(item, projectedBase) {
    var href = '/products/' + encodeURIComponent(item.p.handle);
    var micro = '';
    return '<article class="caza-v4-look-card">' +
      '<a class="caza-v4-look-image" href="' + href + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.p.title) + '" loading="lazy" decoding="async"></a>' +
      '<div class="caza-v4-look-body">' + micro + '<a class="caza-v4-look-title" href="' + href + '">' + escapeHtml(item.p.title) + '</a><span class="caza-v4-look-price">' + money(item.price) + '</span><a class="caza-v4-look-cta" href="' + href + '">Choose options →</a></div>' +
      '</article>';
  }

  function buildCompleteLook(config, cartSubtotal) {
    return; // Caza Oct 8: old 'Complete the look' carousel retired (replaced by caza-complete-look snippet)
    var handles = COMPLETE_LOOK[config.handle];
    if (!handles || handles.length < 3 || q('.caza-v4-complete')) return;

    Promise.all(handles.slice(0, 6).map(fetchProduct)).then(function (items) {
      items = items.filter(Boolean);
      if (items.length < 3) return;

      var current = variantData(config);
      var base = Math.max(0, Number(cartSubtotal || 0)) + Number(current.price || config.initialVariantPrice || 0) * quantity();
      var before = unlockedDiscount(base);

      items.forEach(function (item) {
        var after = unlockedDiscount(base + item.price);
        item.score = 100 - item.index * 10 + (after > before ? 1 : 0);
      });
      items.sort(function (a, b) { return b.score - a.score; });
      items = items.slice(0, 3);

      var section = document.createElement('section');
      section.className = 'caza-v4-complete';
      section.innerHTML =
        '<div class="caza-v4-complete-inner"><div class="caza-v4-complete-head"><div><span>STYLED FOR THIS PIECE</span><h2>Complete the look</h2><p>Three available pieces selected to work naturally with this look.</p></div></div>' +
        '<div class="caza-v4-look-rail">' + items.map(function (item) { return completeCard(item, base); }).join('') + '</div></div>';

      var root = main();
      if (root) root.insertAdjacentElement('afterend', section);
    });
  }

  function moreFromCaza() {
    var section = q('[id^="shopify-section-"][id*="product-recommendations"]');
    if (!section) return;
    section.classList.remove('caza-hide-generic-recommendations');
    section.classList.add('caza-v4-more');
    var heading = q('h2,h3,.t4s-section-title,.t4s-title', section);
    if (heading && /you may also like|recommend/i.test(heading.textContent || '')) heading.textContent = 'More from Cazameeza';
  }

  function hideNoise(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var links = [];
    if (scope.matches && scope.matches('a[href*="makeprosimp" i], [href*="makeprosimp" i]')) links.push(scope);
    if (scope.querySelectorAll) links = links.concat(qa('a[href*="makeprosimp" i], [href*="makeprosimp" i]', scope));
    links.forEach(function (link) {
      var node = link;
      for (var i = 0; i < 7 && node && node !== document.body; i += 1, node = node.parentElement) {
        var style = window.getComputedStyle(node);
        if (style.position === 'fixed' || style.position === 'sticky') {
          node.style.setProperty('display', 'none', 'important');
          node.setAttribute('data-caza-v4-noise', 'true');
          break;
        }
      }
    });
  }

  function cartSubtotal() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart unavailable'); return r.json(); })
      .then(function (cart) { return Number(cart.items_subtotal_price || 0); })
      .catch(function () { return 0; });
  }

  function sync(config, description, subtotal) {
    basePage();
    buildAboveFold(config, description);
    buildPriceSaving(config, subtotal);
    premiumAov();
    buildTrustAndBrand();
    buildDescription(description);
    moreFromCaza();
  }

  function boot() {
    var root = main();
    if (!root) return;

    purgeOldV3();
    var config = cfg();
    var description = cleanDescription();
    basePage();
    hideNoise(document);

    buildAboveFold(config, description);
    premiumAov();
    buildTrustAndBrand();
    buildDescription(description);
    moreFromCaza();

    cartSubtotal().then(function (subtotal) {
      buildPriceSaving(config, subtotal);
      premiumAov();
      buildTrustAndBrand();
      buildCompleteLook(config, subtotal);
    });

    document.addEventListener('variant:changed', function () {
      window.setTimeout(function () {
        cartSubtotal().then(function (subtotal) {
          buildPriceSaving(config, subtotal);
          premiumAov();
        });
      }, 0);
    });

    var frm = form();
    if (frm) {
      frm.addEventListener('input', function (event) {
        if (event.target && (event.target.name === 'quantity' || event.target.hasAttribute('data-quantity-value'))) {
          window.setTimeout(function () {
            cartSubtotal().then(function (subtotal) { buildPriceSaving(config, subtotal); });
          }, 0);
        }
      });
      frm.addEventListener('submit', function () {
        window.setTimeout(function () {
          cartSubtotal().then(function (subtotal) {
            buildPriceSaving(config, subtotal);
            premiumAov();
          });
        }, 800);
      });
    }

    if (window.MutationObserver) {
      var scheduled = false;
      var observer = new MutationObserver(function (mutations) {
        if (!scheduled) {
          scheduled = true;
          window.requestAnimationFrame(function () {
            scheduled = false;
            basePage();
            premiumAov();
            buildTrustAndBrand();
            moreFromCaza();
          });
        }
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node && node.nodeType === 1) hideNoise(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
